import {ModuleConfig} from '@app/app.config';
import {InjectionToken} from '@angular/core';

export const LOGIN_MODULE_CONSTANTS: ModuleConfig = {
  ROUTING: {
    VIEW: {
      EMPTY: '',
    }
  }
};

export let LOGIN_MODULE_CONFIG = new InjectionToken<ModuleConfig>('login.module.config');
